import {
  AppWindow,
  ChartLine,
  ChartPie,
  ChartScatter,
  CircleAlert,
  Clock3,
  ListChecks,
  ListOrdered,
  type LucideIcon,
  Repeat,
  ScanEye,
  ScanSearch,
  ScrollText,
  Split,
  Target,
  Timer,
  Users,
  Waypoints,
  Zap,
} from "lucide-react";

/**
 * Suggestion icons by subject, so a subject reads the same on every page. Suggestions name them by
 * key because page asks are copied through JSON, which would drop a component.
 */
export const ASK_ICONS = {
  apps: AppWindow,
  attention: CircleAlert,
  automation: Zap,
  change: ChartLine,
  divergence: Split,
  duration: Timer,
  investigate: ScanSearch,
  opportunity: Target,
  paths: Waypoints,
  patterns: ChartScatter,
  people: Users,
  performed: ListChecks,
  rework: Repeat,
  share: ChartPie,
  steps: ListOrdered,
  summary: ScrollText,
  time: Clock3,
  unusual: ScanEye,
} satisfies Record<string, LucideIcon>;

export type AskIcon = keyof typeof ASK_ICONS;
